import React, { useReducer, useCallback } from 'react'
import { Button, Box } from '@mui/material'
import ColorButton from '../../Buttons/ColorButton'
import { lockedReducer } from '../../Utils/reducers'

import './styles.css'
import NFSEntrada from './entrada'
import { hasPermissions } from '../../Utils/groups'
import NFSSaida from './saida'
import Apuracao from './apuracao'

const frameMenu = () => ({
    'entrada': { title: 'NFs Entrada', component: (<NFSEntrada />), permission: hasPermissions('grupo_administradores') },
    'saida': { title: 'NFs Saida', component: (<NFSSaida />), permission: hasPermissions('grupo_administradores') },
    'apuracao': { title: 'Apuração', component: (<Apuracao />), permission: hasPermissions('grupo_administradores') }
})

const Prodepe = () => {
    const [state, setState] = useReducer(lockedReducer, {
        tab: 'entrada' || 'saida' || 'apuracao'
    })

    const frame = useCallback(()=>{
        return frameMenu()
    }, [])

    const frame_data = Object.entries(frame()).filter(([_, value]) => value.permission)

    return (
        <>
            <Box className='multitab-select-box'>
                {frame_data.map(([key, value]) => (
                    <ColorButton reverse={state.tab !== key} onClick={() => setState({ tab: key })}>
                        {value.title}
                    </ColorButton>
                ))}
            </Box>
            <Box className='multitab-mainframe'>
                {frame()[state.tab].component}
            </Box>
        </>
    )
}

export default Prodepe